import {
  ClientSubtypeE,
  ClientTypeE,
  PaymentMethodsE,
  PaymentTermsE,
  UserStatusE,
} from "../../../../../models/enums";

import type { GetPredefinedUserDataResultT } from "../../../../../api/models/models";

type UploadedImageFileT = {
  ImageFile: string;
  ImageObjectURL: string;
  ImageSource: string;
};

const mapPayloadForClientPost = (
  data: any,
  clientData: GetPredefinedUserDataResultT,
  img: UploadedImageFileT,
  token: string
) => {
  return {
    Name: data.companyName,
    AdId: null,
    Id: null,
    ClientType: clientData.ClientType,
    ClientSubType: ClientSubtypeE.None,
    Culture: clientData.Language,
    // The admin's choice (carried in the token) wins; the form field is only asked for - and only
    // filled - on legacy links generated before Country existed on the token.
    Country: clientData?.Country || data?.country?.value || "IL",
    ServicePackageId: clientData.ServicePackageId,
    Status: UserStatusE.Enabled,
    ImageFile: img?.ImageFile || null,
    ImageObjectURL: img?.ImageObjectURL || null,
    ImageSource: img?.ImageSource || null,
    CreationDate: null,
    TotalStorageUsed: null,
    ParentClientId: data.ParentClientId?.value || null,
    JumboFormID_EN: data.JumboFormID_EN,
    JumboFormID_HE: data.JumboFormID_HE,
    ClientCurrency: data.ClientCurrency?.value,
    ClientInfo: {
      Phone: clientData.UserPhoneNumber,
      Email: clientData.UserEmail,
      ContactName: "",
      InvoiceName: data?.InvoiceName || "",
      VatNumber: data?.vat || "",
      iCountId: "",
      PaymentMethod:
        clientData.ClientType === ClientTypeE["Post/sound production"] ||
        (clientData.ClientType === ClientTypeE["Advertising Agency"] &&
          clientData.IsDeliveryService)
          ? PaymentMethodsE.CreditCard
          : undefined,
      PaymentTerms:
        clientData.ClientType === ClientTypeE["Post/sound production"] ||
        (clientData.ClientType === ClientTypeE["Advertising Agency"] &&
          clientData.IsDeliveryService)
          ? PaymentTermsE.Current
          : undefined,
      Comment: "",
    },
    Token: token,
  };
};

export default mapPayloadForClientPost;
